<template>
  <v-layout>
    <v-flex xs5 sm6>
      <vc-date-picker
        v-model="selectedDay"
        mode="date"
        :attributes="attributes"
        :locale="locale"
        color="gray"
        :is-required="true"
        :first-day-of-week="2"
        :disabled-dates="{ weekdays: [1, 7] }"
        :model-config="dateModelConfig"
      >
        <template v-slot="{ togglePopover }">
          <v-text-field
            :value="selectedDay"
            :label="$t('editingContainer.orderUntilDay')"
            readonly
            @click="togglePopover()"
          />
        </template>
      </vc-date-picker>
    </v-flex>
    <v-flex xs5 sm6>
      <v-menu
        ref="menu"
        v-model="hourMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        max-width="290px"
        min-width="290px"
        style="width: 100%;"
      >
        <v-text-field
          slot="activator"
          v-model="time"
          :label="$t('editingContainer.orderUntilHour')"
          readonly
        />
        <v-time-picker v-model="time" color="primary" format="24hr" />
      </v-menu>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TimePicker',
  props: {
    orderUntilHour: {
      type: String,
      default: '',
    },
    orderUntilDay: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dayMenu: null,
      hourMenu: null,
      time: this.orderUntilHour,
      selectedDay: null,
      attributes: [
        {
          key: 'today',
          highlight: {
            color: 'gray',
            fillMode: 'outline',
          },
          dates: new Date(),
        },
      ],
      dateModelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      },
    };
  },
  computed: {
    ...mapGetters('userInfoStore', ['locale']),
  },
  watch: {
    orderUntilHour(newVal) {
      this.time = newVal;
    },
    time(newVal, oldVal) {
      if (oldVal && newVal) {
        const [, oldMinutes] = oldVal.split(':');
        const [, newMinutes] = newVal.split(':');
        if (oldMinutes !== newMinutes) {
          this.$refs.menu.save(newVal);
        }

        this.$emit('onTimeChange', newVal);
      }
    },
    orderUntilDay(newValue) {
      this.selectedDay = newValue;
    },
    selectedDay(newValue) {
      this.$emit('onDayChange', newValue);
    },
  },
  methods: {
    notPastDays(date) {
      const day = new Date(date);
      const today = new Date();

      return day >= new Date(today.getFullYear(), today.getMonth(), today.getDate());
    },
  },
};
</script>
